export default {
    OBJECTS: "Объекты",
    OBJECT: "Объект",
    SEARCH_PLACEHOLDER: "Поиск",
    PIN_ROW: "Закрепить",
    UNPIN_ROW: "Открепить",
    PIN_ALL_ROWS: "Закрепить всё",
    UNPIN_ALL_ROWS: "Открепить всё"
};
